import { AllProvincesArray } from "../Data/index";

export const getProvinceName = (stateCode) => {
  const province = AllProvincesArray.find(
    (province) => province.state === stateCode
  );
  return province ? province.name : "";
};
